import { render, staticRenderFns } from "./MyFriends.vue?vue&type=template&id=05eb24c3&scoped=true&"
import script from "./MyFriends.vue?vue&type=script&lang=js&"
export * from "./MyFriends.vue?vue&type=script&lang=js&"
import style0 from "./MyFriends.vue?vue&type=style&index=0&id=05eb24c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb24c3",
  null
  
)

export default component.exports